import OperationalProcessesReportPage from "../../shared/OperationalProcessesReportPage";

const ManagementOperationalProcessesReportPage = () => (
  <OperationalProcessesReportPage operationsSource="Management" />
);

export default ManagementOperationalProcessesReportPage;
